import { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { useResetPasswordMutation } from '../slices/usersApiSlice';
import { toast } from 'react-toastify';

const ResetPasswordScreen = () => {
  const { resetToken } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [resetPassword, { isLoading }] = useResetPasswordMutation();

  const submitHandler = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Wachtwoorden komen niet overeen');
      return;
    }

    if (password.length < 6) {
      toast.error('Wachtwoord moet minimaal 6 tekens lang zijn');
      return;
    }

    try {
      const res = await resetPassword({ resetToken, password }).unwrap();
      toast.success(res.message || 'Wachtwoord succesvol gewijzigd');
      navigate('/login');
    } catch (err) {
      toast.error(err?.data?.message || err.error || 'Kon wachtwoord niet opnieuw instellen');
    }
  };

  return (
    <FormContainer>
      <h1>Nieuw wachtwoord instellen</h1>
      <p className='text-muted'>
        Vul uw nieuwe wachtwoord in om uw account opnieuw te beveiligen.
      </p>

      <Form onSubmit={submitHandler}>
        <Form.Group className='my-3' controlId='password'>
          <Form.Label>Nieuw wachtwoord</Form.Label>
          <Form.Control
            type='password'
            placeholder='Voer nieuw wachtwoord in'
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group className='my-3' controlId='confirmPassword'>
          <Form.Label>Bevestig nieuw wachtwoord</Form.Label>
          <Form.Control
            type='password'
            placeholder='Bevestig nieuw wachtwoord'
            value={confirmPassword}
            required
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Button disabled={isLoading} type='submit' variant='primary' className='mt-2'>
          Wachtwoord opslaan
        </Button>

        {isLoading && <Loader />}
      </Form>

      <div className='py-3'>
        <Link to='/login'>Terug naar inloggen</Link>
      </div>
    </FormContainer>
  );
};

export default ResetPasswordScreen;
